import { render } from "./TwoFactorToggle.vue?vue&type=template&id=51bd9551&scoped=true"
import script from "./TwoFactorToggle.vue?vue&type=script&lang=js"
export * from "./TwoFactorToggle.vue?vue&type=script&lang=js"

import "./TwoFactorToggle.vue?vue&type=style&index=0&id=51bd9551&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51bd9551"]])

export default __exports__